var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.133,
    height: 128.899,
    viewBox: "0 0 101.133 128.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4770",
    "data-name": "Group 4770",
    transform: "translate(-527 -1638.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4769",
    "data-name": "Group 4769",
    transform: "translate(119.835 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3017",
    "data-name": "Group 3017",
    transform: "translate(407.165 1639.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4081",
    "data-name": "Path 4081",
    d: "M1929.822-538.258a13.049,13.049,0,0,1-13.05,13.049h-75.033a13.05,13.05,0,0,1-13.049-13.049v-75.033a13.05,13.05,0,0,1,13.049-13.049h75.033a13.05,13.05,0,0,1,13.05,13.049Z",
    transform: "translate(-1828.69 626.34)",
    fill: "#0a7da7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4085",
    "data-name": "Path 4085",
    d: "M1964.631-233.988l15.577,27.914,15.578-27.914Z",
    transform: "translate(-1929.641 334.974)",
    fill: "#0a7da7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6254",
    "data-name": "Path 6254",
    d: "M1089.652,534.457c-6.139,5.82-19.934,18.907-21.959,20.932-.041.052-.084.1-.127.15a3.592,3.592,0,0,1-5.077.243h0c-1.157-.966-12.219-11.606-22.274-21.325ZM1038,536.618c4.1,3.969,11.449,11.062,16.613,15.994L1038,568.617Zm2.025,34.331,16.813-16.2c2,1.906,3.208,3.023,3.573,3.329a7.032,7.032,0,0,0,4.475,1.666,7.108,7.108,0,0,0,5.045-2.242h0c.4-.4,1.33-1.3,2.826-2.728l16.8,16.173Zm51.812-2.1L1075,552.632h0c5.1-4.871,12.618-12.011,16.833-16.008Z",
    transform: "translate(-487.615 1137.604)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.43151ede0981a270b021457c25ac9c10.svg";
export { ForwardRef as ReactComponent };